// Eine Leitung zu /v2-api/version.
//
// Zwei Stellen wollen dieselbe Antwort aus verschiedenen Gruenden: der
// Seitenfuss zeigt den Build-Stand an (version-info), und die
// Update-Erkennung vergleicht `build_time` gegen das eingebackene
// __APP_BUILD__ (pwa). Beide holten sie getrennt -- im Boot-Wasserfall
// vom 23.08.2026 stand /v2-api/version dreimal, zweimal davon im
// selben Sekundenfenster.
//
// Kein Store und kein Zustand nach aussen: nur die Anfrage selbst wird
// geteilt. Ein laufender Abruf wird mitbenutzt, ein eben erfolgter kurz
// wiederverwendet. Wer bewusst spaeter nachsieht (der 5-Minuten-Takt
// der Update-Erkennung), bekommt trotzdem eine frische Antwort -- das
// Fenster ist absichtlich klein.

export interface VersionPayload {
  version?: string;
  commit?: string;
  build_time?: string;
  go_version?: string;
}

const DEDUPE_MS = 5_000;

let _last: { at: number; data: VersionPayload } | null = null;
let _inflight: Promise<VersionPayload | null> | null = null;

export async function fetchVersion(): Promise<VersionPayload | null> {
  if (_last && Date.now() - _last.at < DEDUPE_MS) return _last.data;
  if (_inflight) return _inflight;
  _inflight = (async () => {
    try {
      // no-store: die Update-Erkennung darf keine gecachte Antwort
      // sehen -- sonst meldet sie den Deploy nie, den sie sucht.
      const r = await fetch("/v2-api/version", {
        credentials: "include",
        cache: "no-store",
      });
      if (!r.ok) return null;
      const data = (await r.json()) as VersionPayload;
      _last = { at: Date.now(), data };
      return data;
    } catch {
      return null;
    } finally {
      _inflight = null;
    }
  })();
  return _inflight;
}
